
import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ModalController } from '@ionic/angular';
import { postRentBulksSuccess } from '@lessor/core/store/multi-rent/multi-rent.actions';
import { Actions, ofType } from '@ngrx/effects';
import { MultiRentsComponent } from '@lessor/pages/scheduler/multi-rents/multi-rents.component';

/**
 * Wrapper modal sobre o `MultiRentsComponent` autônomo. O componente interno
 * já tem botão "Salvar" próprio e dispara `postRentBulks` — aqui só damos um
 * header de modal e fechamos automaticamente quando o success chega via Actions.
 */
import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonTitle, IonToolbar } from '@ionic/angular/standalone';

@Component({
  selector: 'lessor-multi-rents-modal',
  templateUrl: './multi-rents-modal.component.html',
  styleUrls: ['./multi-rents-modal.component.scss'],
  imports: [
    IonButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonIcon,
    IonTitle,
    IonToolbar,
    MultiRentsComponent
  ],
})
export class MultiRentsModalComponent {
  private readonly modalCtrl = inject(ModalController);
  private readonly actions$ = inject(Actions);
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    // Fecha o modal automaticamente quando o batch é criado com sucesso.
    // O MultiRentsComponent abre seu próprio modal de "resultado por slot"
    // antes; aqui só garantimos que este wrapper fecha em sequência.
    this.actions$
      .pipe(ofType(postRentBulksSuccess), takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.modalCtrl.dismiss({ created: true }));
  }

  dismiss() {
    this.modalCtrl.dismiss({ created: false });
  }
}
